module.exports = __webpack_public_path__ + "static/media/pl_outdoor_hot_permacool.00e73724.png";